import React, { Component } from "react";
import { add, format, parseISO } from "date-fns";

import MobileCalender from "@/commonComponents/calendar/MobileCalender";
import autoSuggest from "../../../../lib/autoSuggestExperience";
import commonFunction from "../../../../lib/utils/common";

const popularCities = [
  {
    destination_id: "12633",
    search_text: "Dubai",
    country_name: "United Arab Emirates",
    location_type: 1,
  },
  {
    destination_id: "12630",
    search_text: "Abu Dhabi",
    country_name: "United Arab Emirates",
    location_type: 1,
  },
  {
    destination_id: "12636",
    search_text: "Sharjah",
    country_name: "United Arab Emirates",
    location_type: 1,
  },
  {
    destination_id: "12631",
    search_text: "Ajman",
    country_name: "United Arab Emirates",
    location_type: 1,
  },
  {
    destination_id: "12634",
    search_text: "Fujairah",
    country_name: "United Arab Emirates",
    location_type: 1,
  },
  {
    destination_id: "12635",
    search_text: "Ras Al Khaimah",
    country_name: "United Arab Emirates",
    location_type: 1,
  },
];

const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
};
const fetchData = async (query, callBackFunc) => {
  if (query != "") {
    const res = await autoSuggest({ searchText: query });
    callBackFunc(res);
  } else {
    callBackFunc(null);
  }
};
const debouncedFetchData = debounce((query, cb) => {
  fetchData(query, cb);
}, 400);

export default class MobileTheme2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityName: "",
      countryName: "",
      isAutoSuggestVisible: false,
      checkInOutValue: "",
      checkInValue: null,
      checkOutValue: null,
      isCalendarVisible: false,
      autoSuggestCountryData: [],
      autoSuggestCityData: popularCities,
      selectedAutoSuggestData: null,
      isError: false,
      isDateError: false,
    };
  }

  componentDidMount() {
    this.onChangeCheckInOutValue(new Date());
  }

  onChangeCheckInOutValue = (dateValue) => {
    // console.log("date=value", dateValue);
    this.setState({
      checkInValue: commonFunction.getDateWithFormat(
        // new Date(dateValue),
        add(new Date(dateValue), { days: 7 }),
        this?.props?.dateFormat
      ),
      checkOutValue: commonFunction.getDateWithFormat(
        add(new Date(dateValue), { days: 8 }),
        this?.props?.dateFormat
      ),
      checkInOutValue: commonFunction.getDateWithFormat(
        dateValue,
        this?.props?.dateFormat
      ),
      isDateError: false,
    });
  };

  onChanegeSetActivityName = (value) => {
    this.setState({ activityName: value });
    if (value.trim() == "") {
      this.setState({
        autoSuggestCityData: popularCities,
        isAutoSuggestVisible: false,
        selectedAutoSuggestData: null,
        isError: false,
      });
    } else {
      debouncedFetchData(value, (data) => {
        if (
          data &&
          data.data &&
          data.data.searchBycity &&
          typeof data.data.searchBycity === "object"
        ) {
          // console.log("selectedCity", ...data.data.searchBycity.result);
          this.setState({
            autoSuggestCityData: [...data.data.searchBycity.result],
            isAutoSuggestVisible: true,
          });
        } else if (data && data.data && data.data.status == false) {
          this.setState({
            autoSuggestCityData: popularCities,
            isAutoSuggestVisible: true,
          });
        }
        //   else if(data && data.data && data.data.searchBycountry && typeof (data.data.searchBycountry) === 'object'){
        //     this.setState({ autoSuggestCountryData: [...data.data.searchBycity.result] , isAutoSuggestVisible:true});
        // }
      });
    }
  };

  onClickSearchActivity = () => {
    if (
      !(
        this.state.selectedAutoSuggestData &&
        this.state.selectedAutoSuggestData.search_text
      )
    ) {
      this.setState({ isError: true });
    }
    if (this.state.checkInOutValue == "") {
      this.setState({ isDateError: true });
    }
    if (
      this.state.selectedAutoSuggestData &&
      this.state.selectedAutoSuggestData.search_text &&
      this.state.checkInOutValue
    ) {
      let urlQuery = {
        location: this.state.selectedAutoSuggestData.search_text,
        country: this.state.selectedAutoSuggestData.country_name,
        checkin: format(new Date(this.state.checkInValue), "yyyy-MM-dd"),
        checkout: format(new Date(this.state.checkOutValue), "yyyy-MM-dd"),
        from: 1,
        to: 30,
        search_type: 1,// this.state.selectedAutoSuggestData.location_type,
        search_text: this.state.selectedAutoSuggestData.destination_id,
        currency: "AED",
      };
      commonFunction.redirectTo("/experience/search", urlQuery);
    }
  };
  onClickSetActivityName = (element) => {
    this.setState({
      activityName: element.search_text,
      countryName: element.country_name,
      selectedAutoSuggestData: element,
      isError: false,
    });
  };
  render() {
    return (
      <div
        className=""
        onClick={(e) => {
          e.stopPropagation();
          if (this.state.isAutoSuggestVisible) {
            this.setState({
              isAutoSuggestVisible: false,
            });
          }
          if (this.state.isCalendarVisible) {
            this.setState({
              isCalendarVisible: false,
            });
          }
        }}
      >
        <div className={this.props?.cssfileMobile?.activity_way_title}>
          <img
            src="/images/back-arrow.png"
            alt=""
            class="arrow_image"
            onClick={(e) => {
              e.stopPropagation();
              this.props.onClosePopup();
            }}
          />
          <h2>Experiences</h2>
        </div>
        <div className={this.props?.cssfileMobile?.activity_search_wid_container}>
          <div className="activity_search_wid_main">
            {/* <div className={this.props.cssfileMobile.activity_way_title}>
                          <h2>Experiences</h2>
                      </div> */}
            <div
              className={
                this.props?.cssfileMobile?.activity_search_details_container
              }
            >
              <div
                className={
                  this.props?.cssfileMobile?.activity_search_details_main
                }
              >
                <div
                  className={
                    this.props?.cssfileMobile?.activity_search_details_row
                  }
                >
                  <div
                    className={
                      this.props?.cssfileMobile?.activity_search_column +
                      " " +
                      this.props.cssfileMobile?.activity_search_name
                    }
                  >
                    <div
                      id="search-widget-main"
                      className={
                        this.props.cssfileMobile?.activity_search_wid_inputfield
                      }
                    >
                      {/* <label>{`Enter Destination`}</label> */}
                      <div
                        className={
                          this.props.cssfileMobile
                            .activity_search_wid_inputfield_main
                        }
                      >
                        <div style={{ position: "absolute", top: "10px", right:"17px", alignItems: "center" }}>
                            <img src='/images/search-red.svg' tabIndex="2" style={{ width: "25px", height: "25px", right: "0" }} />
                        </div>
                        <span>
                        <svg version="1.1"
                          id="Layer_1"
                          x="0px"
                          y="0px"
                          width="200px"
                          height="200px"
                          viewBox="0 0 200 200"
                          enableBackground="new 0 0 200 200"
                          >
<g>
	<path fill="currentColor" d="M101,184.511c-0.031,0-0.062,0-0.094-0.001c-1.113-0.026-2.164-0.515-2.902-1.349
		c-1.537-1.736-3.586-4.031-6.147-6.885c-2.659-2.961-7.256-8.648-14.055-17.387c-6.738-8.66-12.719-17.192-17.779-25.359
		c-5.106-8.243-9.814-17.68-13.991-28.049c-4.284-10.633-6.457-20.179-6.457-28.372c0-16.481,5.985-30.635,17.79-42.068
		C69.39,23.395,84.07,17.489,101,17.489s31.546,5.842,43.442,17.365c11.932,11.556,17.982,25.772,17.982,42.255
		c0,8.19-2.106,17.607-6.26,27.989c-4.062,10.15-9.045,19.803-14.812,28.688c-5.665,8.729-11.346,17.015-16.885,24.627
		c-5.553,7.63-10.354,13.807-14.27,18.359c-0.053,0.062-0.107,0.121-0.164,0.18l-6.167,6.346
		C103.114,184.074,102.079,184.511,101,184.511z M101,25.489c-14.988,0-27.441,5.004-38.069,15.298
		C52.599,50.795,47.576,62.676,47.576,77.109c0,7.164,1.977,15.704,5.876,25.382c4.007,9.945,8.506,18.972,13.372,26.826
		c4.91,7.927,10.729,16.224,17.292,24.66c6.589,8.469,11.196,14.174,13.693,16.955c1.222,1.361,2.329,2.597,3.319,3.706l3.084-3.174
		c3.762-4.381,8.399-10.354,13.787-17.758c5.456-7.498,11.056-15.665,16.643-24.275c5.483-8.45,10.226-17.637,14.095-27.305
		c3.774-9.433,5.688-17.85,5.688-25.018c0-14.434-5.086-26.376-15.549-36.508C128.378,30.432,115.988,25.489,101,25.489z"/>
</g>
<g>
	<path fill="currentColor" d="M101,91.748c-7.077,0-12.834-5.757-12.834-12.834S93.923,66.079,101,66.079s12.835,5.757,12.835,12.834
		S108.077,91.748,101,91.748z M101,74.079c-2.666,0-4.834,2.169-4.834,4.834s2.169,4.834,4.834,4.834
		c2.666,0,4.835-2.169,4.835-4.834S103.666,74.079,101,74.079z"/>
</g>
</svg>
                        </span>
                        <input
                          type="text"
                          autoComplete={"off"}
                          id="myTextField"
                          placeholder={`City / Destination / Experience `}
                          readOnly
                          className={
                            this.props.cssfileMobile.search_widget_input_new
                          }
                          value={
                            !commonFunction.isValueEmpty(this.state.activityName) && !this.state.isAutoSuggestVisible
                              ? `${this.state.activityName}, ${this.state.countryName}`
                              : ""
                          }
                          onClick={() => {
                            this.setState((prevState) => {
                              return {
                                isAutoSuggestVisible:
                                  !prevState.isAutoSuggestVisible,
                                isCalendarVisible: false,
                                activityName: '',
                                autoSuggestCityData: popularCities
                              };
                            });
                          }}
                        />
                        {this.state.isError && (
                          <div className={this.props.cssfileMobile.error}>
                            {"Please select your Destination"}
                          </div>
                        )}

                        {this.state.isAutoSuggestVisible === true ? (
                          <div
                            className={
                              this.props.cssfileMobile
                                .activity_autocomplete_value
                            }
                          >


                  <div className={this.props.cssfileMobile.input_search_destination}>
                             <svg width="50px" height="50px" viewBox="0,0,256,256">
                                  <g fill="#3479c5" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none">
                                <g transform="scale(5.12,5.12)"><path d="M21,3c-9.39844,0 -17,7.60156 -17,17c0,9.39844 7.60156,17 17,17c3.35547,0 6.46094,-0.98437 9.09375,-2.65625l12.28125,12.28125l4.25,-4.25l-12.125,-12.09375c2.17969,-2.85937 3.5,-6.40234 3.5,-10.28125c0,-9.39844 -7.60156,-17 -17,-17zM21,7c7.19922,0 13,5.80078 13,13c0,7.19922 -5.80078,13 -13,13c-7.19922,0 -13,-5.80078 -13,-13c0,-7.19922 5.80078,-13 13,-13z"></path></g></g>
                             </svg>  
                          <input
                          type="text"
                          autoComplete={"off"}
                          id="myTextField"
                          placeholder={`City / Destination / Experience `}
                          autoFocus
                          className={
                            this.props.cssfileMobile.search_widget_input_new
                          }
                          value={
                            !commonFunction.isValueEmpty(
                              this.state.activityName
                            )
                              ? this.state.activityName
                              : ""
                          }
                          onChange={(event) => {
                            this.onChanegeSetActivityName(event.target.value);
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState((prevState) => {
                              return {...prevState,
                                isAutoSuggestVisible: true,
                                isCalendarVisible: false,
                                activityName: '',
                              };
                            });
                          }}
                        />
                                                </div>


                            {!commonFunction.isValueEmpty(
                              this.state.autoSuggestCountryData
                            ) &&
                              this.state.autoSuggestCountryData.length > 0 &&
                              this.state.countryData.map((element) => {
                                return (
                                  <div
                                    className={
                                      this.props.cssfileMobile
                                        .activity_autocomplete_element
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.setState({
                                        activityName: element.search_text,
                                        isAutoSuggestVisible: false,
                                      });
                                      this.onClickSetActivityName(element);
                                    }}
                                  >
                                    <img src="images/location-01.svg" alt=""/>
                                    <div>
                                      <div
                                        className={
                                          this.props.cssfileMobile
                                            .activity_autocomplete_name
                                        }
                                      >
                                        {element.search_text}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            {!commonFunction.isValueEmpty(
                              this.state.autoSuggestCityData
                            ) && this.state.autoSuggestCityData.length > 0 ? (
                              this.state.autoSuggestCityData.map((element) => {
                                return (
                                  <div
                                    key={`city-${element.search_text}`}
                                    className={
                                      this.props.cssfileMobile
                                        .activity_autocomplete_element
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      this.setState({
                                        activityName: element.search_text,
                                        countryName: element.country_name,
                                        isAutoSuggestVisible: false,
                                      });
                                      this.onClickSetActivityName(element);
                                    }}
                                  >
                                    <img src="images/location-01.svg" alt=""/>
                                    <div>
                                      <div
                                        className={
                                          this.props.cssfileMobile
                                            .activity_autocomplete_name
                                        }
                                      >
                                        {`${element.search_text}, ${element.country_name}`}
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                key={`noresults`}
                                className={
                                  this.props.cssfileMobile
                                    .activity_autocomplete_element
                                }
                              >
                                <img src="images/location-01.svg" alt=""/>
                                <div>
                                  <div
                                    className={
                                      this.props.cssfileMobile
                                        .activity_autocomplete_name
                                    }
                                  >
                                    No Results Found
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>

                  {/* <div
                    className={`${this.props.cssfileMobile.activity_search_column} ${this.props.cssfileMobile.activity_search_date}`}
                  >
                    <MobileCalender
                      label="Date"
                      styles={this.props.cssfileMobile}
                      //  styles={styles}
                      value={
                        !commonFunction.isValueEmpty(this.state.checkInOutValue)
                          ? this.state.checkInOutValue
                          : ""
                      }
                      placholder="Select the date"
                      onChangeDate={(dateVal) => {
                        this.onChangeCheckInOutValue(dateVal);
                      }}
                      iconImage={"images/calendar-01.svg"}
                      startDate={commonFunction.getDateWithFormat(
                        new Date(),
                        this?.props?.dateFormat
                      )}
                      startDateLimit={commonFunction.getDateWithFormat(
                        new Date(),
                        this?.props?.dateFormat
                      )}
                      dateFormat={this?.props?.dateFormat}
                      changeVisibility={(bool) => {
                        console.log("calander visibile", bool);
                        this.setState({
                          isCalendarVisible: bool,
                          isAutoSuggestVisible: false,
                          isDateError: false,
                        });
                      }}
                      isVisible={this.state.isCalendarVisible}
                      doubleSelection={false}
                    />
                    {this.state.isDateError && (
                      <div className={this.props.cssfileMobile.errordate}>
                        {"Please select Date"}
                      </div>
                    )}
                  </div> */}
                  <div
                    className={`${this.props.cssfileMobile.activity_search_details_row} ${this.props.cssfileMobile.activity_nw}`}
                  >
                    <div
                      className={this.props.cssfileMobile.activity_search_class}
                    >
                      <button
                        className={
                          this.props.cssfileMobile.activity_search_widget_btn
                        }
                       
                        onClick={() => this.onClickSearchActivity()}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
